<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <h2 class="text-center p-3">รายการค่าไฟ</h2>

            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="mr-auto">
                    <span>ห้องพัก : {{ rentalFeeForm.rental_name }}</span>
                    &nbsp; &nbsp; &nbsp;
                    <span>จำนวนผู้พักอาศัย : {{ rentalFeeForm.count }}  คน</span>
                </div>
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <button class="btn btn-warning my-2 my-sm-0"
                                @click="showElectricityBillModal"
                                type="button">
                            <icon name="plus"></icon>
                            บันทึกมิเตอร์ไฟฟ้า
                        </button>
                        &nbsp
                    </form>
                </div>
            </nav>
            <div class="col-12 table-responsive">
                <table style="text-align: center" class="table table-bordered">
                    <thead>
                    <tr>
                        <th rowspan="2" scope="col">วันที่บันทึก</th>
                        <th colspan="2" scope="col">มิเตอร์ไฟฟ้า</th>
                        <th rowspan="2" scope="col">ราคา (หน่วย)</th>
                        <th rowspan="2" scope="col">จำนวน (บาท)</th>
                        <th rowspan="2" scope="col">ผู้บันทึก</th>
                        <th rowspan="2" scope="col">แก้ไข</th>
                    </tr>

                    <tr>
                        <th scope="col">จาก</th>
                        <th scope="col">ถึง</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(data,index) in electricityBillList">
                        <td>{{ data.date_record | moment("DD/MM/YYYY") }}</td>
                        <td>{{ data.unit_before }}</td>
                        <td>{{ data.unit_after }}</td>
                        <td>{{ data.total_unit }}</td>
                        <td>{{ data.total_price | currency }}</td>
                        <td>{{ data.user.name }}</td>
                        <td>
                            <template v-if="index == 0">
                                <a @click="editElectricityBill(data.id,data.unit_before)">
                                    <icon name="pencil-alt"></icon>
                                </a>
                            </template>
                            <template v-else :disabled="1">
                                <a>
                                    <icon name="pencil-alt"
                                          style="color: grey">
                                    </icon>
                                </a>
                            </template>

                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-if="electricityBillList.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getElectricityBillList">
                </vue-pagination>
            </div>
            <br>
            <!--b-modal-->
            <b-modal hide-header hide-footer ref="electricity_bill">
                <electricity-bill-modal @submit="saveElectricityBill"></electricity-bill-modal>
            </b-modal>

        </div>
        <!--        <pre class="alert-success">{{rentalFeeForm.electric_unit}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import ElectricityBillModal from "./Modal/ElectricityBillModal";
import VuePagination from "../../../Pagination";

export default {
    name: "electricity-bill-list",
    components: {
        ElectricityBillModal,
        VuePagination
    },
    created() {
        // this.$store.dispatch("ElectricityBill/setElectricityBill",this.rentalFeeForm.id);
    },
    data() {
        return {
            items: [
                {
                    text: "รายการห้องเช่า",
                    to: {name: "rental-fee"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],

        }
    },
    computed: {
        ...mapState({
            rentalFeeForm: state => {
                return state.RentalFee.rentalFeeForm;
            },
            electricityBillList: state => {
                return state.ElectricityBill.electricityBillList;
            },
            dataPaginate: state => {
                return state.ElectricityBill.dataPaginate;
            },
        }),
    },
    methods: {
        getElectricityBillList() {
            const page = this.dataPaginate.current_page;

            this.$store.dispatch("ElectricityBill/setElectricityBill", {
                rental_fee_id: this.rentalFeeForm.id,
                page: page
            })
        },
        editElectricityBill(id, unit) {
            this.$store.dispatch("ElectricityBill/clearFormData", unit)
            //console.log(unit);
            this.$store.dispatch("ElectricityBill/showElectricityBillByID", id).then(() => {
                this.$refs.electricity_bill.show();
                //console.log(this.rentalFeeForm.electric_unit);
            })
        },
        showElectricityBillModal() {
            this.$store.dispatch("ElectricityBill/clearFormData", this.rentalFeeForm.electric_unit)
            this.$refs.electricity_bill.show();
        },
        hideElectricityBillModal() {
            this.$refs.electricity_bill.hide();
        },

        saveElectricityBill(submitData) {
            if (submitData == 0) {
                //console.log(1);
            } else {
                this.$store.dispatch("ElectricityBill/saveElectricityBill", {
                    id: submitData.id,
                    data: submitData
                }).then(() => {
                    this.$store.dispatch("RentalFee/showRentalFeeByID", this.rentalFeeForm.id).then(() => {
                        this.$store.dispatch("ElectricityBill/setElectricityBill", {
                            rental_fee_id: this.rentalFeeForm.id,
                            page: 1
                        })

                    })
                });
            }
            this.hideElectricityBillModal();
        },
    }
}
</script>

<style scoped>

</style>
